import React from "react";

const ITEMS = [
  "Python",
  "ROS 2",
  "AWS",
  "Kubernetes",
  "Cypress",
  "C++",
  "Linear Algebra",
  "IELTS",
  "Romanian",
  "Solar",
  "PCB Design",
  "Selenium",
  "Rust",
  "Calculus",
  "Spanish",
  "Embedded ARM",
];

export default function Marquee() {
  // Duplicate so it loops seamlessly
  const items = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative overflow-hidden border-y border-eduhu-border bg-eduhu-dark text-eduhu-bg"
      data-testid="discipline-marquee"
    >
      <div className="marquee-track flex gap-0">
        {items.map((it, idx) => (
          <span
            key={idx}
            className="font-serif italic text-3xl md:text-4xl py-5 px-8 whitespace-nowrap flex items-center gap-8"
          >
            {it}
            <span className="text-eduhu-gold">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
